export class FAQ {
    uid: string;
    question: string;
    answer: string;
}



// WEBPACK FOOTER //
// ./src/app/model/faq.ts